"use strict";

// import Vue from "vue";
import axios from "axios";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

axios.defaults.baseURL =
  process.env.baseURL || process.env.VUE_APP_apiUrl || "";
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
axios.defaults.headers.post["Content-Type"] = "multipart/form-data";

let config = {
  baseURL: process.env.baseURL || process.env.VUE_APP_apiUrl || "",
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
  // headers:
  //   process.env.NODE_ENV == "development"
  //     ? {
  //         "Content-Type": "text/plain",
  //       }
  //     : {
  //         "Content-Type": "text/plain",
  //         Authorization: `Bearer a3a0b4a03d76b65522fa24c56c873fe2`,
  //       },
  headers: {
    // Accept: "application/json",
    "Content-Type": "multipart/form-data",
  },
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function (Vue, options) {
  options;
  // Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

// Vue.use(Plugin);

export default _axios;
